<template>
    <div>
        <b-modal
            v-model="isModalVisible"
            hide-footer
            :title="model.id ? 'View Message' : 'Add Message'"
        >
            <b-form-group
                id="fieldset-received"
                label="Received"
                label-cols="3"
                label-class="font-weight-bold pt-0"
                v-if="!!model.id"
            >
                {{ model.created_at | displayTime }}
            </b-form-group>
            <b-form-group
                id="fieldset-sender"
                label="Sender"
                label-cols="3"
                label-class="font-weight-bold pt-0"
                v-if="!!model.id"
            >
                {{ model.user | displayUser }}
            </b-form-group>
            <b-form-group
                id="fieldset-1"
                label="Message"
                label-for="input-content"
                label-cols="3"
                label-class="font-weight-bold pt-0"
            >
                <b-form-textarea
                    :disabled="!!model.id"
                    id="input-content"
                    v-model="model.content"
                    placeholder="Enter Message..."
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </b-form-group>
            <b-button
                size="sm"
                @click="isModalVisible = false"
                variant="warning"
                class="mr-3"
                >Close</b-button
            >
            <b-button
                v-show="!model.id"
                size="sm"
                @click="createNote"
                :disabled="submitting ? true : false"
                variant="primary"
                >Add Message</b-button
            >
        </b-modal>
        <b-button
            size="sm"
            variant="primary"
            @click="
                model.content = ''
                model.id = null
                isModalVisible = true
            "
            > <b-icon icon="plus-circle"></b-icon> New Message</b-button
        >
        <b-table
            id="orderTable"
            :items="messages"
            :fields="fields"
            :busy="tableLoading"
            small
            striped
            selectable
            responsive
            show-empty
            ref="selectableTable"
        >
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

            <template #empty>
                <h4 v-html="emptyText"></h4>
            </template>
            <template #emptyfiltered>
                <h4 v-html="emptyText"></h4>
            </template>

            <template #cell(actions)="{ item }">
                <b-button
                    size="sm"
                    @click="viewNote(item)"
                    class="mr-2"
                    variant="primary"
                >
                    View
                </b-button>
                <b-button
                    size="sm"
                    variant="warning"
                    @click="deleteNote(item.id)"
                    :disabled="submitting ? true : false"
                    >{{ 'Delete' }}</b-button
                >
            </template>

            <template #cell(id)="{ index }">
                <h6>
                    {{ index + 1 }}
                </h6>
            </template>

            <template #cell(content)="{ value }">
                <h6>
                    {{ value.length > 40 ? value.slice(0, 40) + '---' : value }}
                </h6>
            </template>

            <template #cell(created_at)="{ value }">
                <h6>
                    {{ value | displayTime(true) }}
                </h6>
            </template>

            <template #cell(user_id)="{ item }">
                <h6>
                    {{ item.user | displayUser }}
                </h6>
            </template>
        </b-table>
    </div>
</template>

<script>
import moment from 'moment'
import popupMixins from '@/mixins/popupMixins'


export default {
    name: 'notes',
    mixins: [popupMixins],
    props: {
        order: {
            type: Object,
            default() {
                return {
                    notes: [
                        {
                            id: 0,
                            content: '',
                        },
                    ],
                }
            },
        },
    },
    data() {
        return {
            componentName:'Service Message',
            model: {},
            isModalVisible: false,
            tableLoading: false,
            submitting: false,
            fields: [
                {
                    key: 'id',
                    label: '',
                },
                {
                    key: 'actions',
                    label: '',
                },
                {
                    key: 'content',
                    label: 'Messages',
                },

                {
                    key: 'created_at',
                    label: 'Received',
                },
                {
                    key: 'user_id',
                    label: 'Sender',
                },
            ],
            emptyText: '<h4>There are no messages</h4>',
        }
    },
    filters: {
        displayTime(time, isShort) {
            if (isShort) {
                return time.split(' ')[0]
            }
            return moment(time, 'YYYY-MM-DD HH:mm:ss').format(
                'dddd, MMMM Do YYYY, h:mm:ss a'
            )
        },
        displayUser(user) {
            const name = user.first_name + ' ' + user.last_name
            return (user.is_customer_user ? 'Client' : 'Agent') + ':' + name
        },
    },
    computed: {
        messages() {
            const notes = this.order.notes || []
            console.log('notes', notes)
            return notes
        },
    },
    methods: {
        viewNote(item) {
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isModalVisible = true
        },
        createNote() {
            const { content } = this.model
            this.submitting = true
            const order_id = this.order.id
            this.$store
                .dispatch('customerPortal/createNote', { order_id, content })
                .then(() => {
                    this.$store.dispatch(
                        'customerPortal/fetchOrder',
                        this.order.id
                    )
                    this.genericToast(this.componentName,'Added','success','Message successfully added')
                    // this.doToast('Sent!', 'Message Added!', 'success')
                    this.isModalVisible = false
                })
                .catch(error => {
                    console.error(error)
                    this.doToast('Error!', 'Error Adding Note!', 'danger')
                })
                .finally(() => {
                    this.submitting = false
                })
        },

        deleteNote(note_id) {
            const title = 'Delete Note?'
            const message = `Are you sure you want to delete this activity?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return
                const order_id = this.order.id
                this.submitting = true
                this.$store
                    .dispatch('customerPortal/deleteNote', {
                        order_id,
                        note_id,
                    })
                    .then(() => {
                        this.$store.dispatch(
                            'customerPortal/fetchOrder',
                            this.order.id
                        )
                        
                        this.genericToast(this.componentName,'Deleted','success','Message succesfully deleted')
                        //this.doToast('Deleted!', 'Note Deleted!', 'success')
                    })
                    .catch(error => {
                        console.error(error)
                        this.doToast('Error!', 'Error Deleting Note!', 'danger')
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
    },
}
</script>

<style lang="scss" scoped>
</style>